const { compose, join, map, prop } = require('ramda');
module.exports = compose(join(', '), map(prop('name')));
